import React, { useState, useEffect } from "react";

import {
  BarChart,
  ResponsiveContainer,
  Bar,
  Tooltip,
  YAxis,
  XAxis,
  LabelList,
} from "recharts";
import useInterval from "@rooks/use-interval";
import axios from "../../../api/axios";
import clsx from "clsx";

var request_updateTimelineData_safe = true;
var request_updateTotalWeekAgo_safe = true;

function paddingZeroLeft(num) {
  return parseInt(num) < 10 ? "0" + num : num;
}

function getCurrentWeek() {
  let firstDayOfWeek = new Date();
  firstDayOfWeek = firstDayOfWeek.setDate(
    firstDayOfWeek.getDate() - firstDayOfWeek.getDay()
  );
  let lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek = lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);

  return (
    paddingZeroLeft(new Date(firstDayOfWeek).getDate()) +
    "/" +
    paddingZeroLeft(new Date(firstDayOfWeek).getMonth() + 1) +
    " - " +
    paddingZeroLeft(new Date(lastDayOfWeek).getDate()) +
    "/" +
    paddingZeroLeft(new Date(lastDayOfWeek).getMonth() + 1)
  );
}
// const CustomTooltipx = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     if (
//       payload[0] &&
//       payload[1] &&
//       payload[0].value === 0 &&
//       payload[1].value === 0
//     ) {
//       return null;
//     } else if (payload[0] && payload[0].value === 0) {
//       return null;
//     } else if (payload[1] && payload[1].value === 0) {
//       return null;
//     }
//     return (
//       <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
//         {payload.map((obj, index) => (
//           <p
//             className={clsx({})}
//           >{`leaving : ${payload[1].value.toLocaleString()}`}</p>
//         ))}
//         {payload[1] && (
//           <p
//             className={clsx({
//               "text-blue-500 text-opacity-80":
//                 payload[0].dataKey === "entering",
//             })}
//           >{`leaving : ${payload[1].value.toLocaleString()}`}</p>
//         )}
//         {payload[0] && (
//           <p
//             className={clsx({
//               "text-indigo-500 text-opacity-80":
//                 payload[1].dataKey === "leaving",
//             })}
//           >{`entering : ${payload[0].value.toLocaleString()}`}</p>
//         )}
//         {/* <p className="text-gray-400">Total: {totalVisits.toLocaleString()}</p> */}
//       </div>
//     );
//   }

//   return null;
// };

const AtidimChartsWeekly = ({ token }) => {
  const [timelineData, setTimelineData] = useState([
    { date: "1.1", entering: 0, leaving: 0, total: 0 },
  ]);
  const colors = [
    ["#1AFF1A", "#4B0092"],
    ["#FFC20A", "#0C7BDC"],
    ["#FEFE62", "#D35FB7"],
  ];
  const [keys, setKeys] = useState([]);
  const [finishSetup, setFinishSetup] = useState(false);
  const [currentWeek, setCurrentWeek] = useState(getCurrentWeek());
  const [isLoading, setIsLoading] = useState(true);
  const colorTexts = [
    "text-blue-700",
    "text-indigo-700",
    "text-purple-700",
    "text-purple-400",
    "text-green-700",
  ];
  const CustomTooltipx = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      // let currentDay = payload[0].payload.day.split("/");

      return (
        <div className="bg-white shadow-xl p-1 text-sm border rounded-md space-y-1 animate-fadeIn">
          {payload.map((val, index) => (
            <p className="text-white">
              {`${payload[index]["dataKey"]} ${
                payload[index].value.toLocaleString().split("-")[0]
              }`}
            </p>
          ))}
        </div>
      );
    }

    return null;
  };

  function updateTimelineDataAllWeek() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/day/vehicles?token=${token}&currentWeek=${currentWeek}&areas=null`
      )
      .then((res) => {
        let monthFirstDayOfTheWeek = parseInt(
          currentWeek.split("-")[0].split("/")[1]
        );
        let firstDateOfTheWeek = parseInt(
          currentWeek.split("-")[0].split("/")[0]
        );
        let monthLastDayOfTheWeek = parseInt(
          currentWeek.split("-")[1].split("/")[1]
        );
        let lastDateOfTheWeek = parseInt(
          currentWeek.split("-")[1].split("/")[0]
        );
        let map = new Map();
        let data = res.data.flat();
        let devices = [
          ...new Set(
            data.map((obj) => {
              return obj.sensor;
            })
          ),
        ];

        if (monthFirstDayOfTheWeek !== monthLastDayOfTheWeek) {
          let lastDate = new Date(
            new Date().getFullYear(),
            monthFirstDayOfTheWeek,
            0
          ).getDate();
          for (let i = firstDateOfTheWeek; i <= lastDate; i++) {
            let obj = {
              date: `${i}.${monthFirstDayOfTheWeek}`,
              total: 0,
            };
            for (let j = 0; j < devices.length; j++) {
              const element = devices[j].slice(10);
              let keys = [`entering-${element}`, `leaving-${element}`];
              obj[keys[0]] = 0;
              obj[keys[1]] = 0;
              obj["gap"] = 600;
            }
            map.set(i, obj);
          }

          for (let i = 1; i <= lastDateOfTheWeek; i++) {
            let obj = {
              date: `${i}.${monthLastDayOfTheWeek}`,

              total: 0,
            };
            for (let j = 0; j < devices.length; j++) {
              const element = devices[j].slice(10);
              let keys = [`entering-${element}`, `leaving-${element}`];
              obj[keys[0]] = 0;
              obj[keys[1]] = 0;
              obj["gap"] = 600;
            }

            map.set(i, obj);
          }
        } else {
          for (let i = firstDateOfTheWeek; i <= lastDateOfTheWeek; i++) {
            let obj = {
              date: `${i}.${monthLastDayOfTheWeek}`,
              total: 0,
            };
            for (let j = 0; j < devices.length; j++) {
              const element = devices[j].slice(10);
              let keys = [`entering-${element}`, `leaving-${element}`];
              obj[keys[0]] = 0;
              obj[keys[1]] = 0;
              obj["gap"] = 600;
            }
            map.set(i, obj);
          }
        }
        for (let i = 0; i < data.length; i++) {
          let day = data[i]["day"];
          let obj = map.get(day);
          //map returns undefined if day is not in the weekend
          if (obj !== undefined) {
            let dimXY = data[i]["dimXY"];
            let id = data[i]["sensor"].slice(10);
            let keys = [`entering-${id}`, `leaving-${id}`];
            obj[keys[0]] =
              obj[keys[0]] +
              dimXY.filter((dim) => {
                return dim["velY"] < 0;
              }).length;
            obj[keys[1]] =
              obj[keys[1]] +
              dimXY.filter((dim) => {
                return dim["velY"] > 0;
              }).length;
            obj.total = obj[keys[0]] + obj[keys[1]];

            map.set(day, obj);
          }
        }
        let setData = [...map.values()];

        if (setData.length > 0) {
          let keys = Object.keys(setData[0]).slice(2);
          let pairKeys = [];
          for (let i = 0; i < keys.length; i++) {
            let pairs = [];
            pairs.push(keys[i]);
            const id = keys[i].split("-")[1];
            for (let k = i + 1; k < keys.length; k++) {
              const id1 = keys[k].split("-")[1];
              if (id === id1) {
                pairs.push(keys[k]);
              }
            }
            if (pairs.length > 1) pairKeys.push(pairs);
          }
          pairKeys = pairKeys.flat().reverse();
          setKeys((prev) => pairKeys);
          setTimelineData((prev) => setData);
          setFinishSetup(false);
          setIsLoading(false);
        }
      });

    request_updateTimelineData_safe = true;
  }

  useEffect(() => {
    setCurrentWeek(getCurrentWeek());
    setTimeout(() => {
      updateTimelineDataAllWeek();
      updateTimelineDataAllWeek();
    }, 2000);
    return () => {};
  }, []); // eslint-disable-line

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (finishSetup) {
        // updateTimelineDataToday();
        updateTimelineDataAllWeek();
      } else {
        updateTimelineDataAllWeek();
      }
    },
    30000,
    true
  );
  if (isLoading) {
    return (
      <div className="w-full h-44 contents ">
        <div className="bg-gray-200 w-full h-full  rounded-md overflow-hidden transition-all">
          <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent  animate-slide"></div>
        </div>
      </div>
    );
  }
  return (
    <div className="w-full h-full   flex">
      <div className="w-full " key={5}>
        <div className="w-full h-95/100 mt-2  shadow-xl rounded-xl bg-slate-50 ">
          <ResponsiveContainer key={"21"}>
            <BarChart
              data={timelineData}
              margin={{ top: 30, right: 2, left: 20, bottom: 10 }}
              height={200}
            >
              {keys.map((id, index) => (
                <defs>
                  <linearGradient
                    key={id + index}
                    id={id}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="20%"
                      stopColor={colors[index]}
                      opacity={0.3}
                    />
                    <stop offset="95%" stopColor="#8884d8" stopOpacity={0.8} />
                  </linearGradient>
                </defs>
              ))}

              {/* <Tooltip
                coordinate={{ x: 0, y: 0 }}
                offset={-50}
                allowEscapeViewBox={{ x: true, y: true }}
                content={<CustomTooltipx />}
                formatter={(Total) => new Intl.NumberFormat("en").format(Total)}
                // formatter={<customFormatter />}
                cursor={false}
              /> */}
              <XAxis
                axisLine={false}
                tick={{ fontSize: "0.8rem" }}
                interval="preserveStartEnd"
                height={15}
                dataKey="date"
                tickFormatter={(value) =>
                  new Date(
                    new Date().getFullYear(),
                    parseInt(value.split(".")[1]) - 1,
                    parseInt(value.split(".")[0])
                  )
                    .toDateString()
                    .slice(0, 4) +
                  " " +
                  new Intl.NumberFormat("en").format(value)
                }
              />
              <YAxis
                axisLine={false}
                tickLine={true}
                tick={{
                  fontSize: "0.7rem",
                }}
                width={30}
                interval="preserveStartEnd"
                dataKey="total"
                tickFormatter={(value) =>
                  new Intl.NumberFormat("en").format(value)
                }
              />

              {keys.map((id, index) => {
                const bars = [];
                bars.push(
                  <Bar
                    key={id + index}
                    dataKey={id}
                    fill={`url(#${id})`}
                    stackId={id.split("-")[1]}
                    fillOpacity={0.7}
                    markerStart={10}
                  >
                    <LabelList
                      dataKey={id}
                      fontSize={"0.8rem"}
                      position={"top"}
                      valueAccessor={(value) => {
                        return value;
                      }}
                      formatter={(value) =>
                        `${keys[index].split("-")[0]} ` +
                        new Intl.NumberFormat("en").format(value)
                      }
                    ></LabelList>
                  </Bar>
                );
                bars.push(
                  <Bar
                    stackId={id.split("-")[1]}
                    dataKey="gap"
                    height={200}
                    width={200}
                    fill="transparent"
                  ></Bar>
                );
                return bars;
              })}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
export default AtidimChartsWeekly;
